module.exports = __webpack_public_path__ + "media/images/commercial_offers/turbotrucks-logo-big-ec942d6cb883aee5072bbd735a0e98e0.png";